import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-coming-soon',
  templateUrl: './coming-soon.component.html',
  styleUrls: ['./coming-soon.component.scss']
})
export class ComingSoonComponent implements OnInit {

  constructor(private title:Title,private meta:Meta,private renderer: Renderer2,@Inject(PLATFORM_ID) private platformId: Object) {
    this.setSeoMeta()
   }

  ngOnInit(): void {
  }
    setSeoMeta() {
    const supportedLanguages = ['en', 'fr', 'es', 'pt'];
    let finalUrl = '';
  
    if (isPlatformBrowser(this.platformId)) {
      const origin = window.location.origin;
      const path = window.location.pathname;
      const parts = path.split('/');
  
      let lang = 'en'; // Default
      if (supportedLanguages.includes(parts[1])) {
        lang = parts[1];
      }
  
      // const fullPath = path.replace(/^\/[a-z]{2}/, '');
      // finalUrl = `${origin}/${lang}${fullPath}`;
      const fullPath = path.replace(/^\/[a-z]{2}/, '').replace(/\/+$/, ''); // remove trailing slash
finalUrl = `${origin}/${lang}${fullPath ? '/' + fullPath : ''}`;

    }
  

    const seoData = {
      title: 'Medeil: Exciting New Features and Solutions Coming Soon',
      description:
        'Get ready for Medeil’s next-generation pharmacy solutions. Explore upcoming features designed to streamline pharmacy operations, enhance patient care, and boost efficiency across healthcare services.',
      image: 'https://www.medeil.com/en/assets/medeil-pharmacy-software.jpg',
      url: finalUrl,
      keywords:
        'Medeil new features, pharmacy software update, healthcare SaaS innovations, patient care technology, pharmacy efficiency tools'
    };

  
      // this.seoService.setData(seoData);
      this.title.setTitle(seoData.title);
      const metaTags = [
        { name: 'description', content: seoData.description },
        { name: 'keywords', content: seoData.keywords }, 
        { property: 'og:title', content: seoData.title },
        { property: 'og:description', content: seoData.description },
        { property: 'og:url', content: seoData.url },
        { property: 'og:type', content: 'website' },
        { property: 'og:image', content: seoData.image }
      ];
    
      metaTags.forEach(tag => this.meta.updateTag(tag));
    }

}
